jQuery(document).ready(function () {

    let images = jQuery('.rte img:not([class*=noauto])');

    images.each(function (index, img) {
        img = jQuery(img);

        if (img[ 0 ].complete && img[ 0 ].naturalWidth !== 0) {
            processImage(img);
        } else {
            img.on('load', function () {
                processImage(img);
            });
        }
    });


    function processImage(img) {
        let alignement = img.hasClass('gauche') ? 'gauche' : ( img.hasClass('droite') ? 'droite' : ( img.hasClass('centre') ? 'centre' : '' ) );

        if (!alignement) {
            switch (img.css('float')) {
                case 'left':
                    alignement = 'gauche';
                    break;
                case 'right':
                    alignement = 'droite';
                    break;
                default:
                    alignement = 'centre';
            }
            img.css('float', 'none');
        } else {
            img.removeClass(alignement);
        }

        let caption = '';
        if (img.prop('title')) {
            caption = jQuery('<figcaption/>').html(img.prop('title'));
        }

        let width = img.width();
        let fig = img.parents('figure');

        if (fig.length == 0) {
            fig = jQuery('<figure class="th ' + alignement + '">');
            fig.append(img.clone());
            fig.append(caption);
            fig.css('max-width', width);
            img.replaceWith(fig);
        } else {
            fig.addClass('th ' + alignement).append(caption).css('max-width', width);
        }
    }

    /*modal*/


});

